import { createFileRoute } from '@tanstack/react-router';
import { FeeBundlesPage } from '../../features/catalogue';

export const Route = createFileRoute('/portal/catalogue/fee-bundles')({ component: FeeBundlesPage });
